"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultPortalId;

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

function defaultPortalId() {
  return _PortalIdParser.default.get();
}

module.exports = exports.default;